// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FiltersTags_wrap__1ujBf"};